<template>
  <div class="popup_wrap">
    <div class="popup_tit">
      <div>{{popupTitle}}</div>
<!--      <div class="popup_close" @click="hidePopup">팝업 닫기 버튼</div>-->
    </div>
    <div class="popup_content">
      <component :is="popupComponent" :popupParams="popupData" @hidePopup="hidePopup" @setSelectedItemList="setSelectedItemList"/>
    </div>
    <template v-if="isCommonPopup">
      <!-- 공용 닫기 UI를 사용하는 팝업 -->
      <div class="popup_btn_wrap">
        <div class="btn_positive" v-if="popupComponent === 'ModemViewPopup'" @click="editModem">수정</div>
        <div class="btn_close" @click="hidePopup">닫기</div>
      </div>
    </template>
    <template v-else>
      <!-- 별도의 닫기 UI를 가진 팝업 -->
    </template>
  </div>
</template>

<script>
import common from '../../script/common'
import MemberPopup from './MemberPopup.vue'
import MemberSearchPopup from './MemberSearchPopup.vue'
import ModemSearchPopup from './ModemSearchPopup.vue'
import ModemViewPopup from '../modemInfo/ModemViewPopup.vue'
import ModemHistoryPopup from '../modemInfo/ModemHistoryPopup.vue'
import ModemASRequestPopup from '../modemAS/ModemASRequestPopup.vue'
import ModemASProgressPopup from '../modemAS/ModemASProgressPopup.vue'
import ShadowQualityRequestPopup from '../shadowQuality/ShadowQualityRequestPopup.vue'
import ShadowQualityProgressPopup from '../shadowQuality/ShadowQualityProgressPopup.vue'
import FailedDescPopup from './FailedDescPopup.vue'

export default {
  components: {
    MemberPopup,
    MemberSearchPopup,
    ModemSearchPopup,
    ModemViewPopup,
    ModemHistoryPopup,
    ModemASRequestPopup,
    ModemASProgressPopup,
    ShadowQualityRequestPopup,
    ShadowQualityProgressPopup,
    FailedDescPopup
  },
  props: ['popupParams'],
  data () {
    return {
      // Common Data
      mySession: {},
      // Popup Data
      popupTitle: this.popupParams.title,
      popupComponent: this.popupParams.component,
      popupData: this.popupParams.data,
      isCommonPopup: false
    }
  },
  mounted () {
    common.getSession(response => {
      if (response.data.resultCode === 1 && response.data.result != null && response.data.result.userPid != null && response.data.result.userRole != null) {
        this.mySession = response.data.result
      }
    })
    this.popupTitle = this.popupParams.title
    this.popupComponent = this.popupParams.component
    this.popupData = this.popupParams.data
    this.isCommonPopup = this.popupComponent === 'ModemViewPopup' || this.popupComponent === 'ModemHistoryPopup' || this.popupComponent === 'MemberPopup'
  },
  watch: {
    popupParams () {
      this.popupTitle = this.popupParams.title
      this.popupComponent = this.popupParams.component
      this.popupData = this.popupParams.data
    }
  },
  methods: {
    hidePopup (args) {
      this.$emit('hidePopup', args)
    },
    setSelectedItemList (args) {
      this.$emit('setSelectedItemList', args)
    },
    editModem () {
      if ((this.mySession.subRole & 1) === 0) {
        common.amsAlert('general', '권한이 없습니다.')
        return
      }
      let list = []
      list.push(this.popupData.data)
      const result = common.checkUserRoleAndList(this.mySession, 4, list, 'edit', 'MODEM')
      if (!result.code) {
        return
      }
      this.$emit('editModem', this.popupData.data)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Popup.vue